<template>
  <component :is="tag" class="display-h1">
    <span v-if="lead">{{ lead }}<template v-if="accent">&nbsp;</template></span>
    <span v-if="accent" class="serif">{{ accent }}</span>
    <slot />
  </component>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    /** Plain text before the serif italic accent word(s). */
    lead?: string;
    /** Italic serif word(s). */
    accent?: string;
    tag?: "h1" | "h2";
  }>(),
  { tag: "h1" },
);
</script>
